"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPage = exports.PageGlobalStyle = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _PageGlobalStyleMixin = require("../../mixins/components/PageGlobalStyleMixin");
var _PageMixin = require("../../mixins/components/PageMixin");
var PageGlobalStyle = /*#__PURE__*/(0, _styledComponents.createGlobalStyle)(["", ""], _PageGlobalStyleMixin.PageGlobalStyleMixin);
exports.PageGlobalStyle = PageGlobalStyle;
var StyledPage = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPage",
  componentId: "c11n-8-107-0__sc-tzx3f5-0"
})(["", ""], _PageMixin.PageMixin);
exports.StyledPage = StyledPage;